import Vue            from 'vue';
import Router         from 'vue-router';
import Home           from './views/Home.vue';

import Workouts       from './views/workouts';
import workoutShow    from './views/workouts/show';
import activeWorkout  from './views/workouts/active';

import Settings       from './views/Settings';

import Calendar       from './views/Calendar';

// # Account
import Login          from '@/views/Login.vue';

// 404
import NotFound       from '@/views/NotFound.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    
    {
      path: '/workouts',
      name: 'workouts',
      component: Workouts,
    },
    {
      path: '/workouts/:id',
      name: 'workoutShow',
      component: workoutShow,
    },
    {
      path: '/workout',
      name: 'activeWorkout',
      component: activeWorkout,
    },
    
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
    },
    
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar,
    },

    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    
    { path: '/404',             component: NotFound },
    { path: "*",                component: NotFound }
    
  ],
});
